<div *ngIf="login; else noLogin">
  <router-outlet></router-outlet>
</div>

<ng-template #noLogin>
  <app-navigation></app-navigation>

  <main [ngClass]="{ 'py-0 px-0 my-0 mx-0': specialPage }" class="mx-lg-4">
    <div class="mt-1">
      <router-outlet></router-outlet>
    </div>
  </main>

  <app-footer></app-footer>

  <!-- Modal global para resultados de conversión NV a facturas -->
  <app-modal-resultados-conversion></app-modal-resultados-conversion>
</ng-template>
